<div class="view-container">
  <div class="users">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Your users</label>
          <button 
            mat-flat-button type="button"
            color="accent"
            (click)="newUser()"
            matTooltip="Add User">
            <mat-icon>add</mat-icon>Add User
          </button>
        </div>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search users by email, first name or last name</mat-label>
                <input matInput type="text"
                  [(ngModel)]="emailFilter"
                  (keyup.enter)="loadUsers()"
                  (keyup.esc)="emailFilter=''; loadUsers()"
                  name="searchTerm"
                  placeholder="Search Name">
                <button mat-button *ngIf="emailFilter" matSuffix mat-icon-button aria-label="Clear" (click)="emailFilter=''; loadUsers()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="10px">
                <button
                  type="submit"
                  mat-flat-button color="primary"
                  (click)="loadUsers()"
                  matTooltip="Search"
                  [class.button-spinner]="loading"
                  [disabled]="loading">
                  <mat-icon>search</mat-icon> Search
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="contrast" *ngFor="let item of userDataSource.data"
          [class.banner-error]="!item?.isEnabled"
          [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px">
            <div fxLayout="column" fxLayoutAlign="start start" fxLayout.lt-sm="column" fxLayoutGap="8px">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.userName | encodeHtml | highlight: emailFilter"></strong>
                <small class="text-info">{{ item?.firstName }} {{ item?.lastName }}</small>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                <small class="text-info">roles</small>
                <div><small>{{ displayRoles(item) }}</small></div>
              </div>
            </div>
            <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="10px">
              <button mat-icon-button color="accent" aria-label="Edit User" matTooltip="Edit User" (click)="onClickUser(item)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="accent" aria-label="Copy User" matTooltip="Copy User" (click)="onClickCopyUser(item)">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button *ngIf="showViewAs(item)" mat-icon-button color="primary" aria-label="View as user" matTooltip="View as user" (click)="onClickViewAsUser(item.id, item.email)">
                <mat-icon>badge</mat-icon>
              </button>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>
